import { Banner } from './banner-config.entity';
import { DisclaimerConfig } from './disclaimer-config.entity';
import { MaintenanceNotification } from './maintenance-notification.entity';
import { ImageFitMode } from './picture-fill-mode.entity';
import { ReadExportMode } from './read-export-mode.entity';
import { TrackingItem } from './tracking-item.entity';

export interface SettingsConfig {
    readonly parentSite: string;
    readonly parentSiteLabel: string;

    readonly siteIsPrivate: boolean;

    readonly banner: Banner;
    readonly disclaimerConfig: DisclaimerConfig;

    readonly readExportMode: ReadExportMode;
    readonly maintenanceNotification: MaintenanceNotification;

    readonly portalUploadProjectUrl: string;
    readonly enableRegistration: boolean;

    readonly adminEmail: string;
    readonly tracking: TrackingItem[];

    readonly zoneId: string;

    readonly enableAiKeywordSuggestions: boolean;
    readonly defaultMapView: {
        readonly clientCoordinate: google.maps.LatLngLiteral;
        readonly zoomLevel: number;
    };

    readonly isDefaultApp: boolean;

    readonly deleteRecycleDelay: number;

    readonly enablePimFeatures: boolean;

    readonly imageFitMode: ImageFitMode;
}

export const defaultSettingsConfig: SettingsConfig = {
    parentSite: '',
    parentSiteLabel: '',
    siteIsPrivate: false,
    banner: {
        enabled: false
    },
    disclaimerConfig: {
        enabled: false
    },
    readExportMode: ReadExportMode.None,
    maintenanceNotification: {
        enabled: false
    },
    portalUploadProjectUrl: '',
    enableRegistration: false,
    adminEmail: '',
    tracking: [],
    zoneId: '',
    enableAiKeywordSuggestions: false,
    defaultMapView: {
        clientCoordinate: {
            lat: 0,
            lng: 0
        },
        zoomLevel: 0
    },
    deleteRecycleDelay: 180,
    isDefaultApp: true,
    enablePimFeatures: false,
    imageFitMode: ImageFitMode.CONTAIN
};
